import api from "app/api";
import { Options } from "common";

export interface ProgramItem {
  id: number;
  name: string;
  display_name: string;
  color: string;
  code: string;
  sku: string;
  review_template: string;
  duration: number;
  partner_booking_close_minutes?: number;
  has_options: boolean;
  sort_by: number;
  always_visible: boolean;
  armband: boolean;
  active: boolean;
  partner_visible: boolean;
  ready_tracking: boolean;
  kid_ticket_available: boolean;
  self_seating: boolean;
  seating_layout_ids: number[];
  kitchen?: boolean;
  scheduled?: boolean;
}

export type ProgramOptions = Options<"role" | "status">;

export function getProgramService(scope?: any) {
  return api.getService<ProgramItem, ProgramItem, ProgramOptions>("programs", {
    scope,
    //params goes here
  });
}

export function copyProgram(id: number) {
  return api.post(`/programs/${id}/copy`);
}
